import { Menu, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { MenuButton } from '@tassat/button';
import { ActionTypes } from '@tassat/common-definitions';
import React from 'react';

import { DEFAULT_ICON_COLOR } from 'Lib/constant';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';
import { PledgeTransactionRow } from 'SharedComponents/modals/pledgeDetailsModal/pledgeContextWorkflow/pledgeContextWorkflowContext';

export interface PledgeAction {
    actionText: string;
    handleAction: (data: PledgeTransactionRow) => void;
}

interface PledgeActionsDropdownMenuProps {
    actions: PledgeAction[];
    data: PledgeTransactionRow;
}

const useStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    menuPopup: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyDark ||
        '#333333'}`
    }
}));

export function PledgeActionsDropdownMenu({ actions, data }: PledgeActionsDropdownMenuProps) {
    const classes = useStyles();

    const [ actionMenuAnchor, setActionMenuAnchor ] = React.useState<null | HTMLElement>(null);
    const handleActionMenuClose = () => setActionMenuAnchor(null);

    const renderActionMenuItems = () => {
        return actions.map((action, index) => (
            <MenuItem
                key={`pledge_action_${index}`}
                onClick={() => {
                    handleActionMenuClose();
                    action.handleAction(data);
                }}
            >
                {action.actionText}
            </MenuItem>
        ));
    };

    return (
        <>
            <MenuButton
                handleClick={(e) => setActionMenuAnchor(e.currentTarget)}
                iconColor={DEFAULT_ICON_COLOR}
                type={ActionTypes.show_actions}
            />
            <Menu
                anchorEl={actionMenuAnchor}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                id='pledge-actions-menu'
                keepMounted
                onClose={handleActionMenuClose}
                open={!!actionMenuAnchor}
                PopoverClasses={{ paper: classes.menuPopup }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                {renderActionMenuItems()}
            </Menu>
        </>
    );
}

export default PledgeActionsDropdownMenu;